import { computed, ref, watch } from 'vue'

const translations = {
  en: {
    language: 'Language',
    launch: 'Play',
    tos: 'Terms of Service',
    licenseAgreement: 'Third party copyright license agreements >>',
    version: 'Version',
    confirm: 'Confirm',
    cancel: 'Cancel',
    settings: 'Settings',
    updating: 'Downloading updates',
    checkingForUpdates: 'Checking file integrity',
    selectGamePath: 'Select game path',
    gamePathSet: 'Game path set',
    gameFilesUpdated: 'Game files updated',
    gameLaunched: 'Game launched',
    gameRunning: 'In Game',
    configSaved: 'Configuration saved',
    fillRequiredFields: 'Please fill in all required fields',
    actionAfterRunGame: 'Action after running the game',
    clientId: 'Client ID',

    additionalGameParameters: 'Additional Game Parameters',
    gameRenderer: 'Game Renderer',

    actionCloseLauncher: 'Close Launcher',
    actionMinimizeLauncher: 'Minimize Launcher',
    actionDoNothing: 'Leave Launcher Open',

    notEnoughDiskSpace: 'Not enough disk space for download game files. Required: {requiredSpace}, Free: {freeSpace}',

    success: 'Success',
    error: 'Error',
    info: 'Info'
  },

  pl: {
    language: 'Język',
    launch: 'Uruchom',
    tos: 'Regulamin',
    licenseAgreement: 'Umowy licencyjne stron trzecich >>',
    version: 'Wersja',
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
    settings: 'Ustawienia',
    updating: 'Pobieranie aktualizacji',
    checkingForUpdates: 'Sprawdzanie spójności plików',
    selectGamePath: 'Wybierz ścieżkę do gry',
    gamePathSet: 'Ścieżka do gry ustawiona',
    gameFilesUpdated: 'Pliki gry zaktualizowane',
    gameLaunched: 'Gra uruchomiona',
    gameRunning: 'W grze',
    configSaved: 'Konfiguracja zapisana',
    fillRequiredFields: 'Proszę wypełnić wszystkie wymagane pola',
    actionAfterRunGame: 'Akcja po uruchomieniu gry',
    clientId: 'ID klienta',

    additionalGameParameters: 'Dodatkowe parametry gry',
    gameRenderer: 'Renderer gry',

    actionCloseLauncher: 'Zamknij launcher',
    actionMinimizeLauncher: 'Zminimalizuj launcher',
    actionDoNothing: 'Pozostaw launcher otwarty',

    notEnoughDiskSpace: 'Nie wystarczająco miejsca na dysku do pobrania plików gry. Wymagane: {requiredSpace}, Wolne: {freeSpace}',

    success: 'Sukces',
    error: 'Błąd',
    info: 'Informacja'
  }
}

const currentLanguage = ref('en')

async function loadConfig() {
  const config = await window.api.readConfig()

  if (!translations[config.language]) {
    setLanguage('en')
    currentLanguage.value = 'en'
    return
  }

  currentLanguage.value = config.language
}

export const $t = (key, params = {}) => {
  return computed(() => {
    let text = translations[currentLanguage.value][key] || key

    Object.entries(params).forEach(([param, value]) => {
      text = text.replace(new RegExp(`{${param}}`, 'g'), value)
    })

    return text
  })
}

export const setLanguage = (lang) => {
  if (translations[lang]) {
    currentLanguage.value = lang
  }
}

watch(currentLanguage, (newLang) => {
  window.api.saveConfig({ language: newLang })
})

await loadConfig()